export default __webpack_public_path__ + "static/groundFloor-26f858882181bf6759a05460e31f9f8d.png";